import * as Sentry from "@sentry/react";
import { logActivity } from "./activityLog";

// Identifiers, timestamps and the reason code only: this channel never carries the
// patient label the refusal sentinel holds for the Recordings modal.
export function reportIdentityParked({ reason, recordingId, chatId, startedAt, createdOn }) {
  try {
    logActivity("recording.parked", { chatId, reason, recordingId });
    Sentry.captureMessage("recording: parked identity mismatch", {
      level: "warning",
      extra: { reason, recordingId, chatId, startedAt, createdOn },
    });
  } catch (_) {
    // telemetry must never change what happens to the recording
  }
}

export function reportIdentityOverride({ recordingId, chatId }) {
  try {
    logActivity("recording.override", { chatId, recordingId });
  } catch (_) {
    // telemetry must never change what happens to the recording
  }
}
